import styled from 'styled-components';

export const SettingsRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
`;

export const SettingsInfo = styled.div`
  margin-right: 10px;
`;

export const SettingsDescription = styled.div`
  margin-top: 0.25rem;
  word-break: break-word;
`;
